import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=7931b39c&"
import script from "./Warning.vue?vue&type=script&lang=js&"
export * from "./Warning.vue?vue&type=script&lang=js&"
import style0 from "./Warning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7931b39c')) {
      api.createRecord('7931b39c', component.options)
    } else {
      api.reload('7931b39c', component.options)
    }
    module.hot.accept("./Warning.vue?vue&type=template&id=7931b39c&", function () {
      api.rerender('7931b39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Warning.vue"
export default component.exports